var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImprovement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 31.5V6.25C11.25 6.11193 11.3619 6 11.5 6H30M30 6L37.5 13.5M30 6V13.25C30 13.3881 30.1119 13.5 30.25 13.5H37.5M37.5 13.5V41C37.5 41.1381 37.3881 41.25 37.25 41.25H11.5C11.3619 41.25 11.25 41.1381 11.25 41V35.25M33 17.25H15M15 12.25H24",
    stroke: "#20376A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 28.375L22.8333 31.5L31.5 24",
    stroke: "#BF9C41",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4773 22.6113C24.0793 22.5382 23.6691 22.5 23.25 22.5C19.5221 22.5 16.5 25.5221 16.5 29.25C16.5 32.9779 19.5221 36 23.25 36C26.9779 36 30 32.9779 30 29.25C30 27.9512 29.6332 26.7381 28.9975 25.7086",
    stroke: "#BF9C41",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprovement);
export default __webpack_public_path__ + "static/media/Improvement.6f4472ab077644f7b3da4993dfea5afe.svg";
export { ForwardRef as ReactComponent };